// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import FilterDrawerController from "./filter_drawer_controller"
application.register("filter-drawer", FilterDrawerController)

import FilterValueController from "./filter_value_controller"
application.register("filter-value", FilterValueController)

import CascadingFilterValueController from "./cascading_filter_value_controller"
application.register("cascading-filter-value", CascadingFilterValueController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import PaginationController from "./pagination_controller"
application.register("pagination", PaginationController)

import PrintSelectionController from "./print_selection_controller"
application.register("print-selection", PrintSelectionController)

import ArchiveShippedController from "./archive_shipped_controller"
application.register("archive-shipped", ArchiveShippedController)

import ArchiveCompletedController from "./archive_completed_controller"
application.register("archive-completed", ArchiveCompletedController)

import ArchiveProductsController from "./archive_products_controller"
application.register("archive-products", ArchiveProductsController)

import ArchiveProductCostingsController from "./archive_product_costings_controller"
application.register("archive-product-costings", ArchiveProductCostingsController)

import ArchiveMaintenanceRequestsController from "./archive_maintenance_requests_controller"
application.register("archive-maintenance-requests", ArchiveMaintenanceRequestsController)

import SelectionStatsController from "./selection_stats_controller"
application.register("selection-stats", SelectionStatsController)

import ExportModalController from "./export_modal_controller"
application.register("export-modal", ExportModalController)

import NavbarDrawerController from "./navbar_drawer_controller"
application.register("navbar-drawer", NavbarDrawerController)

import TableActionsMenuController from "./table_actions_menu_controller"
application.register("table-actions-menu", TableActionsMenuController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToastTriggerController from "./toast_trigger_controller"
application.register("toast-trigger", ToastTriggerController)

import PollingController from "./polling_controller"
application.register("polling", PollingController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import OrderTrackEditController from "./order_track_edit_controller"
application.register("order-track-edit", OrderTrackEditController)

import OrderTrackFormController from "./order_track_form_controller"
application.register("order-track-form", OrderTrackFormController)

import ProductionTrackSortableController from "./production_track_sortable_controller"
application.register("production-track-sortable", ProductionTrackSortableController)

import ProductionMachineEditController from "./production_machine_edit_controller"
application.register("production-machine-edit", ProductionMachineEditController)

import ProductionTrackEditController from "./production_track_edit_controller"
application.register("production-track-edit", ProductionTrackEditController)

import PoTrackEditController from "./po_track_edit_controller"
application.register("po-track-edit", PoTrackEditController)

import PoTrackNotificationController from "./po_track_notification_controller"
application.register("po-track-notification", PoTrackNotificationController)

import UserEditController from "./user_edit_controller"
application.register("user-edit", UserEditController)

import ProductFormController from "./product_form_controller"
application.register("product-form", ProductFormController)

import MaintenanceRequestFormController from "./maintenance_request_form_controller"
application.register("maintenance-request-form", MaintenanceRequestFormController)

import QualityAssuranceAuditFormController from "./quality_assurance_audit_form_controller"
application.register("quality-assurance-audit-form", QualityAssuranceAuditFormController)

import CustomerSearchController from "./customer_search_controller"
application.register("customer-search", CustomerSearchController)

import CustomerEditController from "./customer_edit_controller"
application.register("customer-edit", CustomerEditController)

import CustomerFormController from "./customer_form_controller"
application.register("customer-form", CustomerFormController)

import ContactEmailCheckController from "./contact_email_check_controller"
application.register("contact-email-check", ContactEmailCheckController)

import VendorSearchController from "./vendor_search_controller"
application.register("vendor-search", VendorSearchController)

import MaintenanceRequestEditController from "./maintenance_request_edit_controller"
application.register("maintenance-request-edit", MaintenanceRequestEditController)

import MaintenanceRequestDocumentsController from "./maintenance_request_documents_controller"
application.register("maintenance-request-documents", MaintenanceRequestDocumentsController)

import ClaimTrackFormController from "./claim_track_form_controller"
application.register("claim-track-form", ClaimTrackFormController)

import ClaimTrackEditController from "./claim_track_edit_controller"
application.register("claim-track-edit", ClaimTrackEditController)

import ClaimTrackDocumentsController from "./claim_track_documents_controller"
application.register("claim-track-documents", ClaimTrackDocumentsController)

import ProductEditController from "./product_edit_controller"
application.register("product-edit", ProductEditController)

import ProductCostingFormController from "./product_costing_form_controller"
application.register("product-costing-form", ProductCostingFormController)

import ProductCostingEditController from "./product_costing_edit_controller"
application.register("product-costing-edit", ProductCostingEditController)

import ResellCalculatorSelectionController from "./resell_calculator_selection_controller"
application.register("resell-calculator-selection", ResellCalculatorSelectionController)

import ResellCalculatorController from "./resell_calculator_controller"
application.register("resell-calculator", ResellCalculatorController)

import TreemapChartController from "./treemap_chart_controller"
application.register("treemap-chart", TreemapChartController)

import PriceHistoryChartController from "./price_history_chart_controller"
application.register("price-history-chart", PriceHistoryChartController)

import EmailReportRecipientsController from "./email_report_recipients_controller"
application.register("email-report-recipients", EmailReportRecipientsController)
